<!-- ── CASHFLOW STEP 2 — Property & Financing ── -->
<app-ip-shell [activeStep]="2" [steps]="cfSteps" calculatorName="Cash Flow Calculator">

  <!-- ── FORM COLUMN ── -->
  <div formCol>
    <div class="ip-form-head">
      <div class="ip-form-head__step-meta">Step 02 &middot; Property &amp; Financing</div>
      <h1 class="ip-form-head__title">Property &amp; financing details</h1>
      <p class="ip-form-head__subtitle">
        Enter the property value and mortgage setup. Your cash flow projections update as you configure.
      </p>
    </div>

    <div class="ip-form-body">

      <!-- Property Value -->
      <div class="ip-field">
        <label class="ip-field__label" for="propertyValue">Property value</label>
        <div class="ip-input">
          <span class="ip-input__prefix">£</span>
          <input
            type="text"
            id="propertyValue"
            class="ip-input__field"
            autocomplete="off"
            placeholder="e.g. 250,000"
            [(ngModel)]="propertyValueDisplay"
            (keyup)="propertyValueDisplay=validation.amountWithComma(propertyValueDisplay); updatePreview()"
            (keypress)="validation.numberOnly($event)">
        </div>
      </div>

      <!-- Mortgage toggle -->
      <div class="ip-field">
        <label class="ip-field__label">Will you need a mortgage?</label>
        <div class="ip-segmented">
          <button class="ip-segmented__option" [class.is-active]="optmortgage==='1'" (click)="optmortgage='1'; updatePreview()" type="button">Yes</button>
          <button class="ip-segmented__option" [class.is-active]="optmortgage==='0'" (click)="optmortgage='0'; updatePreview()" type="button">No — All Cash</button>
        </div>
      </div>

      <!-- Mortgage details -->
      <div class="ip-conditional-group" [class.is-hidden]="optmortgage==='0'">
        <div class="ip-conditional-group__head">Mortgage configuration</div>

        <!-- LTV -->
        <div class="ip-field">
          <div class="ip-field__head">
            <label class="ip-field__label">Loan to Value (LTV)</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>Higher LTV = less deposit required</span>
          </div>
          <div class="ip-chip-row">
            <button class="ip-chip" [class.is-active]="loanAmount==='50'" (click)="loanAmount='50'; updatePreview()" type="button">50%</button>
            <button class="ip-chip" [class.is-active]="loanAmount==='55'" (click)="loanAmount='55'; updatePreview()" type="button">55%</button>
            <button class="ip-chip" [class.is-active]="loanAmount==='60'" (click)="loanAmount='60'; updatePreview()" type="button">60%</button>
            <button class="ip-chip" [class.is-active]="loanAmount==='65'" (click)="loanAmount='65'; updatePreview()" type="button">65%</button>
            <button class="ip-chip" [class.is-active]="loanAmount==='70'" (click)="loanAmount='70'; updatePreview()" type="button">70%</button>
            <button class="ip-chip" [class.is-active]="loanAmount==='75'" (click)="loanAmount='75'; updatePreview()" type="button">75%</button>
            <button class="ip-chip" [class.is-active]="loanAmount==='80'" (click)="loanAmount='80'; updatePreview()" type="button">80%</button>
          </div>
        </div>

        <!-- Interest Rate -->
        <div class="ip-field">
          <div class="ip-field__head">
            <label class="ip-field__label" for="interestRate">Interest rate</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>Current avg: 5.2%</span>
          </div>
          <div class="ip-input">
            <input
              type="text"
              id="interestRate"
              class="ip-input__field"
              autocomplete="off"
              placeholder="e.g. 5.0"
              [(ngModel)]="interestRate"
              (keyup)="interestRate=validation.appendPercent($event,interestRate); updatePreview()"
              (keypress)="validation.DesimalOnly($event,interestRate)">

          </div>
        </div>

        <!-- Loan Tenure -->
        <div class="ip-field">
          <div class="ip-field__head">
            <label class="ip-field__label">Loan tenure</label>
            <span class="ip-hint"><span class="ip-hint__dot"></span>Typical residential: 25–35 years</span>
          </div>
          <div class="ip-chip-row">
            <button class="ip-chip" [class.is-active]="loanTenure==='5'"  (click)="loanTenure='5';  updatePreview()" type="button">5 yrs</button>
            <button class="ip-chip" [class.is-active]="loanTenure==='10'" (click)="loanTenure='10'; updatePreview()" type="button">10 yrs</button>
            <button class="ip-chip" [class.is-active]="loanTenure==='15'" (click)="loanTenure='15'; updatePreview()" type="button">15 yrs</button>
            <button class="ip-chip" [class.is-active]="loanTenure==='20'" (click)="loanTenure='20'; updatePreview()" type="button">20 yrs</button>
            <button class="ip-chip" [class.is-active]="loanTenure==='25'" (click)="loanTenure='25'; updatePreview()" type="button">25 yrs</button>
          </div>
        </div>

        <!-- Mortgage Type -->
        <div class="ip-field">
          <label class="ip-field__label">Mortgage type</label>
          <div class="ip-segmented">
            <button class="ip-segmented__option" [class.is-active]="mortgageType==='1'" (click)="mortgageType='1'; updatePreview()" type="button">Interest Only</button>
            <button class="ip-segmented__option" [class.is-active]="mortgageType==='2'" (click)="mortgageType='2'; updatePreview()" type="button">Repayment</button>
          </div>
        </div>

      </div><!-- /mortgage details -->

      <!-- All-cash notice -->
      <div class="ip-cash-notice" [class.is-hidden]="optmortgage!=='0'">
        <div class="ip-cash-notice__icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2v20M5 9h14M5 15h14"></path></svg>
        </div>
        <div>
          <span class="ip-cash-notice__title">All-cash purchase</span>
          <span class="ip-cash-notice__sub">No mortgage repayments — your full rental income improves net cash flow.</span>
        </div>
      </div>

    </div><!-- /ip-form-body -->

    <div class="ip-form-actions">
      <button class="ip-btn ip-btn--ghost" type="button" [routerLink]="['/cashflow/step1']">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>
        </svg>
        Back
      </button>
      <button class="ip-btn ip-btn--primary" type="button" (click)="next()">
        Continue
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>
        </svg>
      </button>
    </div>
  </div><!-- /formCol -->

  <!-- ── RAIL ── -->
  <div rail>
    <div class="ip-rail-summary">
      <div class="ip-rail-summary__head">
        <div class="ip-rail-summary__loc">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>
          </svg>
          <span class="ip-rail-summary__loc-name">{{ calcData?.City || 'United Kingdom' }}</span>
        </div>
        <div class="ip-rail-summary__buyer-tag" [class.is-uk]="calcData?.ForeignBuyer!=='1'">
          {{ calcData?.ForeignBuyer === '1' ? 'Foreign Buyer' : 'UK Resident' }}
        </div>
      </div>

      <div class="ip-rail-summary__body">
        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Property &amp; Financing</span>
          </div>
          <div class="ip-rs-row" *ngIf="propertyValueDisplay">
            <span class="ip-rs-row__key">Property value</span>
            <span class="ip-rs-row__val">£{{ propertyValueDisplay }}</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Financing</span>
            <span class="ip-rs-row__val">{{ optmortgage === '0' ? 'All-cash' : loanAmount + '% LTV' }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="optmortgage==='1'">
            <span class="ip-rs-row__key">Type · Tenure</span>
            <span class="ip-rs-row__val">{{ mortgageType === '1' ? 'Interest Only' : 'Repayment' }} · {{ loanTenure }} yrs</span>
          </div>
        </div>

        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Cash Flow Preview</span>
          </div>
          <div class="ip-rs-row">
            <span class="ip-rs-row__key">Deposit</span>
            <span class="ip-rs-row__val">£{{ deposit | number:'1.0-0' }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="optmortgage==='1'">
            <span class="ip-rs-row__key">Loan amount</span>
            <span class="ip-rs-row__val">£{{ loanAmountVal | number:'1.0-0' }}</span>
          </div>
          <div class="ip-rs-row" *ngIf="optmortgage==='1'">
            <span class="ip-rs-row__key">Annual mortgage</span>
            <span class="ip-rs-row__val">£{{ annualMortgage | number:'1.0-0' }}</span>
          </div>
        </div>

        <div class="ip-rs-section">
          <div class="ip-rs-section__head">
            <span class="ip-rs-section__label">Rental Income</span>
          </div>
          <div class="ip-rs-row ip-rs-row--placeholder">
            <span class="ip-rs-row__key">Yield, growth, period</span>
            <span class="ip-rs-row__val">Step 3</span>
          </div>
        </div>
      </div>

      <div class="ip-rail-summary__outlay">
        <div class="ip-rail-summary__outlay-label">Deposit required</div>
        <div class="ip-rail-summary__outlay-value">£{{ deposit | number:'1.0-0' }}</div>
        <div class="ip-rail-summary__outlay-meta">Based on {{ loanAmount }}% LTV</div>
      </div>
    </div>
  </div><!-- /rail -->

</app-ip-shell>
